import { createContext } from 'react';
import type { InterpreterFrom } from 'xstate';

import type { flightFareSelectionMachine } from './index';

export type ContextValue = InterpreterFrom<typeof flightFareSelectionMachine>;

const flightFareSelectionXStateContext = createContext<ContextValue | null>(null);

export default flightFareSelectionXStateContext;
